module.exports = __webpack_public_path__ + "static/media/return-name-global.36445d7b.png";